import { render, staticRenderFns } from "./Terminos.vue?vue&type=template&id=a0d0f25e"
import script from "./Terminos.vue?vue&type=script&lang=js"
export * from "./Terminos.vue?vue&type=script&lang=js"
import style0 from "./Terminos.vue?vue&type=style&index=0&id=a0d0f25e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports